import React from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox, Table } from 'semantic-ui-react'
import { Category, Manager, PopupOptionsType } from '~/api/services/loginPopups'
import { MANAGER_ROLE_SLUG } from '~/Constants'
import { DataFields } from '../style'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { Nullable } from '~/types'

export const FIELD_ACTION = {
  NONE: 0,
  DISPLAY: 1,
  CHANGE: 2,
  REQUEST_NEW: 3
}

export const CATEGORY_ORDER: Category[] = [
  Category.UserData,
  Category.ManagerData,
  Category.FarmerData
]

export interface OrderedField {
  roleSlug: string
  field: Manager
  index: number
}

interface DataFieldsTableProps {
  roleSlug: string
  optionsData: Nullable<PopupOptionsType>
}

const DataFieldsTable: React.FC<DataFieldsTableProps> = ({ roleSlug, optionsData }) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields, update } = useFieldArray({
    control,
    name: 'fields',
    keyName: 'key'
  })

  function getSectionTitle(category: string) {
    switch (category) {
      case Category.UserData:
        return t('User identification')
      case Category.ManagerData:
        return t('Manager information')
      case Category.FarmerData:
        return roleSlug === MANAGER_ROLE_SLUG ? t('Assigned operation(s)') : t('Farm information')
      default:
        return ''
    }
  }

  function renderActionCheckbox(available: boolean, actionValue: number, index: number) {
    if (!available) {
      return null
    }
    //@ts-ignore
    const currentAction = fields[index]?.action
    return <Checkbox
      onChange={() => {
        update(index, { ...fields[index], action: actionValue, required: 1 })
      }}
      checked={currentAction === actionValue}
      label={''}
    />
  }

  function renderRow(field) {
    const index = fields.findIndex(fieldItem => fieldItem.key === field.key)
    const fieldOption = optionsData?.fields?.manager?.find(fieldItem => fieldItem.slug === field.slug)
    return <Table.Row key={field.slug}>
      <Table.Cell className='label-cell'>{field.label}</Table.Cell>
      <Table.Cell textAlign='center'>
        {fieldOption.required ? (
          <Checkbox checked disabled label={''} />
        ) : (
          <Checkbox
            //@ts-ignore
            checked={fields[index]?.required === 1}
            onChange={(_, { checked }) => {
              update(index, {
                ...fields[index],
                required: checked ? 1 : 0,
                action: checked ? FIELD_ACTION.DISPLAY : FIELD_ACTION.NONE
              })
            }}
            label={''}
          />
        )}
      </Table.Cell>
      <Table.Cell textAlign='center'>{renderActionCheckbox(field.showAvailable === 1, FIELD_ACTION.DISPLAY, index)}</Table.Cell>
      <Table.Cell textAlign='center'>{renderActionCheckbox(field.changeAvailable === 1, FIELD_ACTION.CHANGE, index)}</Table.Cell>
      <Table.Cell textAlign='center'>{renderActionCheckbox(field.requestNewAvailable === 1, FIELD_ACTION.REQUEST_NEW, index)}</Table.Cell>
    </Table.Row>
  }
  console.log(fields)
  return <>
    {CATEGORY_ORDER.map(category => {
      const categoryItems = fields.filter(item => item['category'] === category)
      if (categoryItems.length === 0) {
        return null
      }
      return <DataFields.DataTableSection key={category}>
        <DataFields.DataTable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{getSectionTitle(category)}</Table.HeaderCell>
              <Table.HeaderCell className='center' textAlign='center'>{t('Mandatory field?')}</Table.HeaderCell>
              <Table.HeaderCell className='center' textAlign='center'>{t('Display?')}</Table.HeaderCell>
              <Table.HeaderCell className='center' textAlign='center'>{t('Change?')}</Table.HeaderCell>
              <Table.HeaderCell className='center' textAlign='center'>{t('Request again?')}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {categoryItems.map(renderRow)}
          </Table.Body>
        </DataFields.DataTable>
      </DataFields.DataTableSection>
    })}
  </>
}

export default DataFieldsTable
